export default "__VITE_ASSET__CSYE7swQ__"